import React, { useEffect, useRef, useState } from "react"
import {
  ButtonDropdown,
  FlatIconAndText,
  FlatIconAndText2Row,
  SwitchToggle,
  TabLog,
  TabsComponent,
  TextAreaInput,
  UploadComponent
} from "../../../../component/index.jsx"
import { CardDetailUsaha } from "./tab/BusinessTab.jsx"
import { CardDetailFarmer } from "./tab/FarmerTab.jsx"
import { CardDetailMitra } from "./tab/MitraTab.jsx"
import { ModalChangeStatus } from "./ModalChangeStatus.jsx"
import { useDispatch, useSelector } from "react-redux"
import {
  clearDataDetail,
  clearSyncErp,
  deactivateStatusMitra,
  getCheckCanDeactivate,
  getDetail,
  renewMitraContract,
  resetCheckCanDeactivate,
  syncErp,
  updateImage,
  updateStatus
} from "../../../../redux/actions/MitraAction.jsx"
import { Button } from "react-bootstrap"
import { useSubheader } from "../../../../_metronic/layout/index.js"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule.jsx"
import { Popup, PopupQuestion } from "../../../../component/atoms/Popup/index.jsx"
import {
  clearUploadAction,
  resetUrlResponse,
  uploadAction
} from "../../../../redux/actions/MasterDataAction.jsx"
import { Form, Formik, FormikProvider, useFormik } from "formik"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/index.js"
import * as yup from "yup"
import swal from "sweetalert"
import { ENUM_LOG, MITRA, UPLOAD } from "../../../../constants/InitTypeConstants.js"
import { loadUserLogin } from "../../../service/userManagementAction.js"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import { stringFormatting, toRupiah } from "../../../helpers/TextHelper.js"
import { ResetIsFinish } from "../../../../redux/actions/GeneraActions.jsx"
import { Skeleton } from "@material-ui/lab"
import {
  ACTION_INIT_TYPE,
  DATE_TYPE_ENUM,
  MITRA_ACTIVE_CONTRACT_STATUS_ENUM,
  FARMER_GENDER,
  MITRA_STATUS,
  MITRA_TYPE,
  ROUTING_STATUS,
  UI_STATUS
} from "../../../../constants/StringConstant.js"
import { PRIVILEGE_ENUM } from "../../../../constants/PrivilegeConstants.js"
import { useTranslation } from "react-i18next"
import { initDate, SelectDateRange } from "../../../../component/atoms/SelectDateRange/index.jsx"
import { UploadIcon } from "../../../../component/atoms/Icons/SVG/upload.jsx"
import { VARIABLE_CONSTANT } from "../../../../constants/VariableConstant.js"
import { ContractTab } from "./tab/ContractTab.jsx"
import { StatusHistoryTab } from "./tab/StatusHistoryTab.jsx"
import { capitalize } from "@material-ui/core/utils"
import { format } from "date-fns"
import { getUrlParsingPageFilter } from "../../../../config/EndpointCollection.js"
import { Card, CardBody } from "../../../../_metronic/_partials/controls/index.js"
import { BaseMap } from "../../master-data/base/detail/component/BaseMap.jsx"
import SVG from "react-inlinesvg"

export const DetailMitra = ({
  history,
  match: {
    params: { status, id }
  }
}) => {
  const privileges = loadUserLogin().privilege
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const { General, Mitra, MasterData } = useSelector((state) => state)
  const { t } = useTranslation()
  const [state, setState] = useState({
    tabsChildren: false
  })

  // notification
  const [rejectReasons, setRejectReasons] = useState({
    reasons: ""
  })
  const [showPopupReject, setShowPopupReject] = useState(false)
  const [showPopupApprove, setShowPopupApprove] = useState(false)
  const [showPopup, setShowPopup] = useState({
    show: false,
    body: ""
  })
  const [swalIcon, setSwallIcon] = useState("")
  const [swalRedirect, setSwalRedirect] = useState("")
  const [activeUser, setActiveUser] = useState(true)
  const [showModalChangeStatus, setShowModalChangeStatus] = useState(false)
  const [listMitra, setListMitra] = useState([])
  const [statusPopup, setStatusPopup] = useState(null)
  const formRef = useRef()
  const [openDate, setOpenDate] = useState(false)
  const [selectedDate, setSelectedDate] = useState(false)
  const [fileAttachments, setFileAttachments] = useState([])
  const [showPinLocation, setShowPinLocation] = useState(false)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues : {
      file_contract_url : null,
      contract_date: initDate,
      file_contract_name: null,
      file_contract_size: null
    },
    validationSchema: yup.object({}),
    onSubmit: (values) => {
      const contractDate = values.contract_date?.[0]
      const body = {
        file_contract_url: values.file_contract_url,
        contract_date_start: selectedDate && contractDate?.startDate
          ? format(contractDate.startDate, DATE_TYPE_ENUM.ISO_DATE_EURO)
          : null,
        contract_date_end: selectedDate && contractDate?.endDate
          ? format(contractDate.endDate, DATE_TYPE_ENUM.ISO_DATE_EURO)
          : null,
        file_contract_name: values.file_contract_name,
        file_contract_size: values.file_contract_size
      }
      if (Mitra.data?.status === UI_STATUS.ACTIVE) {
        handleRenewContract(body)
      } else {
        handleApproval(ROUTING_STATUS.STATUS_ENUM.ACTIVE, null, body)
      }
    }
  })

  useEffect(() => {
    if (General.isFinishUpdateOrDelete) {
      if (
        General.actionInitType !== ACTION_INIT_TYPE.MITRA.DEACTIVATE_MITRA &&
        General.actionInitType !== ACTION_INIT_TYPE.MITRA.UPLOAD &&
        General.actionInitType !== ACTION_INIT_TYPE.MITRA.UPDATE_IMAGE &&
        General.actionInitType !== ACTION_INIT_TYPE.MITRA.SYNC_ERP
      ) {
        history.push(swalRedirect)

        dispatch(ResetIsFinish())
        swal({
          text: Mitra.messages,
          icon: swalIcon,
          buttons: {
            okey: { text: "Ok", className: "sweet-success" }
          }
        }).then((value) => {
          switch (value) {
            case "detail":
              return history.push(swalRedirect)
            default:
              return
          }
        })
      } else if (General.actionInitType === MITRA.DEACTIVATE_MITRA) {
        history.push(RoutesConstants.MITRA.DETAIL_MITRA(ROUTING_STATUS.STATUS_STRING.INACTIVE, id))
          dispatch(resetCheckCanDeactivate())
          setShowModalChangeStatus(false)
          dispatch(getDetail(id))

          subHeader.setButton(
            <Button className="btn btn-dark" disabled={true}>
              Edit
            </Button>
          )
          swal({
            text: Mitra.messages,
            icon: toAbsoluteUrl(ILLUSTRATION_CONSTANTS.MITRA.SUCCES_MITRA_NONACTIVE)
          })
      } else if (General.actionInitType === ACTION_INIT_TYPE.MITRA.UPLOAD) {
        if (MasterData.uploadType !== UPLOAD.BUSINESS_DOCUMENT) {
          const data = {
            upload_enum: statusPopup,
            url: MasterData.urlResponseUpload,
            mitra_type_enum: Mitra?.data?.mitra_type
          }
          dispatch(updateImage({ id, data }))
        }
      } else if (General.actionInitType === ACTION_INIT_TYPE.MITRA.UPDATE_IMAGE) {
        dispatch(getDetail(id))
      }
    }
  }, [General.isFinishUpdateOrDelete, Mitra])

  useEffect(() => {
    if (General.isFinishSyncErp) {
      swal({
        text: Mitra.messages,
        icon: toAbsoluteUrl(ILLUSTRATION_CONSTANTS.MITRA.SUCCESS_SEND_ERP)
      })
      dispatch(clearSyncErp())
    }
  }, [General.isFinishSyncErp, Mitra])

  useEffect(() => {
    dispatch(resetCheckCanDeactivate())
    dispatch(getDetail(id))
    dispatch(clearUploadAction())
    return () => {
      dispatch(clearDataDetail())
    }
  }, [])

  useEffect(() => {
    const mitraStatus =
      (status.toUpperCase() === ROUTING_STATUS.STATUS_ENUM.ACTIVE && MITRA_STATUS.ACTIVE) ||
      (status.toUpperCase() === ROUTING_STATUS.STATUS_ENUM.PENDING && MITRA_STATUS.WAITING) ||
      ((status.toUpperCase() === ROUTING_STATUS.STATUS_ENUM.REJECTED ||
        status.toUpperCase() === ROUTING_STATUS.STATUS_ENUM.REJECT) &&
        MITRA_STATUS.REJECT) ||
      (status.toUpperCase() === ROUTING_STATUS.STATUS_ENUM.INACTIVE && MITRA_STATUS.INACTIVE)
    subHeader.setBreadcrumbs([
      {
        pathname: RoutesConstants.MITRA.LIST_MITRA(ROUTING_STATUS.STATUS_ENUM.PENDING),
        title: "Mitra"
      },
      {
        pathname: RoutesConstants.MITRA.LIST_MITRA(status.toUpperCase()),
        title: mitraStatus
      },
      {
        title: Mitra?.data?.name
      }
    ])
    subHeader.setTitle(t("sub_header_mitra_detail"))
    if (status === "pending") {
      if (privileges.indexOf(PRIVILEGE_ENUM.APPROVAL_MITRA_REGISTRATION) > -1) {
        subHeader.setButton(
          <RowModule>
            <>
              <Button
                variant="danger"
                onClick={() => {
                  setShowPopupReject(true)
                }}>
                Reject
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  setShowPopupApprove(true)
                }}
                className="ml-2">
                Approve
              </Button>
            </>
          </RowModule>
        )
      }
    } else if (status === ROUTING_STATUS.STATUS_STRING.REJECTED) {
      if (privileges.indexOf(PRIVILEGE_ENUM.UPDATE_MITRA) > -1) {
        subHeader.setButton(
          <Button
            className={"btn btn-outline-primary"}
            onClick={() => history.push(RoutesConstants.MITRA.EDIT_MITRA(status, id))}>
            Edit
          </Button>
        )
      }
    } else {
      if (privileges.indexOf(PRIVILEGE_ENUM.UPDATE_MITRA) > -1) {
        subHeader.setButton(<ButtonDropdown title={"Action"} dropdownList={listDropdown} />)
      }
    }
  }, [Mitra.data])

  useEffect(() => {
    if (id) {
      dispatch(getDetail(id))
    }
  }, [dispatch])

  useEffect(() => {
    if (Mitra?.combobox) {
      setListMitra(
        Mitra?.combobox.map((e) => ({
          label: e?.name + ", " + e?.id,
          value: e?.id
        }))
      )
    }
  }, [Mitra?.combobox])

  useEffect(() => {
    if (Mitra?.data) {
      if (Mitra?.canDeactivate?.status === true) {
        setShowModalChangeStatus(true)
      } else if (Mitra?.canDeactivate?.status === false) {
        swal({
          text: Mitra?.canDeactivate?.message,
          icon: toAbsoluteUrl(ILLUSTRATION_CONSTANTS.MITRA.CANNOT_CHANGE)
        })
      }
    }
  }, [Mitra.canDeactivate])

  useEffect(() => {
    if (MasterData.urlResponseUpload) {
      if (!General.loading) {
        if (MasterData.uploadType === UPLOAD.BUSINESS_DOCUMENT) {
          formik.setFieldValue("file_contract_url", MasterData.urlResponseUpload)
        }
      }
      setTimeout(() => {
        dispatch(resetUrlResponse())
      }, 200)
    }
  }, [MasterData.urlResponseUpload, General.loading, MasterData.uploadType])

  const handleApproval = (status, reasons, file) => {
    dispatch(updateStatus(id, status, reasons, file))
  }

  const handleRenewContract = (body) => {
    dispatch(renewMitraContract(id, body))
  }

  const descriptionLeft = (data) => {
    return (
      <>
        <div className="d-flex flex-row">
          <div className="d-flex flex-wrap mb-2">
            <FlatIconAndText text={stringFormatting(data?.code)} svg={ICON_CONSTANTS.MITRA_SMALL} />
            <FlatIconAndText
              text={stringFormatting(data?.regional)}
              svg={ICON_CONSTANTS.PIN_LOCATION_2}
            />
            <FlatIconAndText
              text={stringFormatting(data?.sub_regional_name)}
              svg={ICON_CONSTANTS.PIN_LOCATION_2}
            />
            <FlatIconAndText text={stringFormatting(data?.email)} svg={ICON_CONSTANTS.MAIL} />
            {(data?.mitra_type === MITRA_TYPE.INDIVIDUAL || data?.mitra_type === MITRA_TYPE.RETAILER_MAI) && (
              <FlatIconAndText text={data?.gender === FARMER_GENDER.MEN ? t("label_men"): t("label_woman")} svg={ICON_CONSTANTS.GENDER} />
            )}
            {(data?.mitra_type === MITRA_TYPE.INDIVIDUAL || data?.mitra_type === MITRA_TYPE.RETAILER_MAI) && (
              <FlatIconAndText
                text={stringFormatting(data?.dob)}
                svg={ICON_CONSTANTS.MENU_CALENDAR}
                svgStyle={{ width: 12, height: 12 }}
              />
            )}
            {privileges.indexOf(PRIVILEGE_ENUM.MITRA_PHONE_NUMBER) > -1 && (
              <FlatIconAndText
                text={stringFormatting(data?.phone_number)}
                svg={ICON_CONSTANTS.PHONE}
              />
            )}
          </div>
        </div>
        {General.loading ? (
          <>
            <Skeleton animation="wave" variant={"text"} width={250} />
          </>
        ) : data?.status === ROUTING_STATUS.STATUS_ENUM.ACTIVE ||
          data?.status === ROUTING_STATUS.STATUS_ENUM.REJECTED ? (
          <div className={"d-flex"}>
            <FlatIconAndText
              className={"text-dark-50 font-weight-bold mr-lg-2 mb-lg-0 mb-2"}
              text={data?.district + ", " + data?.regency + ", " + data?.province}
              svg={ICON_CONSTANTS.DIRECTION}
            />
            {data?.latitude && data?.longitude ? (
              <a
                className={"link"}
                onClick={() => {
                  setShowPinLocation(true)
                }}>
                {t("button_see_detail")}
              </a>
            ) : (
              <>
                <label className={"mr-2 text-dark-50 font-weight-bold"}>
                  ({t("location_pin_not_set")})
                </label>
                <a
                  className={"link"}
                  onClick={() => history.push(RoutesConstants.MITRA.EDIT_MITRA(status, id))}>
                  {t("set_pin_location")}
                </a>
              </>
            )}
          </div>
        ) : (
          <FlatIconAndText
            text={
              <>
                <span className={"text-dark-50"}>
                  {[
                    Mitra.data?.address,
                    Mitra.data?.sub_district,
                    Mitra.data?.district,
                    Mitra.data?.regency,
                    Mitra.data?.province + " " + Mitra.data?.postal_code
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </span>
              </>
            }
            svg={ICON_CONSTANTS.DIRECTION}
          />
        )}
      </>
    )
  }

  const descriptionRight = () => {
    return (
      <>
        {(status === ROUTING_STATUS.STATUS_STRING.ACTIVE ||
          status === ROUTING_STATUS.STATUS_STRING.INACTIVE) && (
          <div className="d-flex flex-column">
            <SwitchToggle
              checked={activeUser}
              label="Status User"
              onChange={inactiveUserMitra}
              withLabel={true}
              withStatusText={true}
              statusText={activeUser ? t("label_active") : t("label_inactive")}
              disabled={!activeUser ? true : false}
            />
          </div>
        )}
      </>
    )
  }

  const flatIconAndText2Rows = (data) => {
    return (
      <>
        <FlatIconAndText2Row
          title={t("label_number_of_farmers")}
          description={data?.total_farmer ? data?.total_farmer + " Petani" : "-"}
          svg={ICON_CONSTANTS.FARMER_BIG}
        />
        <FlatIconAndText2Row
          title="Total Plafon KUR BNI"
          description={data?.kur_plafond ? toRupiah(data?.kur_plafond) : "-"}
          svg={ICON_CONSTANTS.INCOME}
        />
        <FlatIconAndText2Row
          title={t("label_bank_name")}
          description={data?.bank_name ?? "-"}
          svg={ICON_CONSTANTS.BANK}
        />
        <FlatIconAndText2Row
          title={t("label_account_name")}
          description={data?.bank_account_name ?? "-"}
          svg={ICON_CONSTANTS.REKENING}
        />
        {privileges.indexOf(PRIVILEGE_ENUM.MITRA_BANK_ACCOUNT_NO) > -1 && (
          <FlatIconAndText2Row
            title={t("label_account_number")}
            description={data?.bank_account_number ?? "-"}
            svg={ICON_CONSTANTS.BANK_ACCOUNT}
          />
        )}
      </>
    )
  }

  const mitraFullAddress = (data) => {
    return (
      <>
        {data?.shop_address +
          " " +
          data?.shop_sub_district_name +
          ", " +
          " " +
          data?.shop_district_name +
          ", " +
          data?.shop_regency_name +
          ", " +
          data?.shop_province_name}
      </>
    )
  }

  useEffect(() => {
    if (Mitra.data) {
      setActiveUser(
        Mitra?.data?.mitra_activation?.toUpperCase() === ROUTING_STATUS.STATUS_ENUM.ACTIVE
      )
      setState({
        ...state,
        tabsChildren: [
          {
            id: "detail",
            title: t("label_detail_mitra").toUpperCase(),
            view: (
              <CardDetailMitra
                titleCardDetail={Mitra.data?.name + " (" + Mitra.data?.mitra_type_name + ")"}
                descriptionLeft={descriptionLeft(Mitra.data)}
                descriptionRight={descriptionRight(Mitra.data)}
                flatIconAndText2Rows={flatIconAndText2Rows(Mitra.data)}
                ktpCardDetail={Mitra.data?.ktp_pic_url}
                swafotoCardDetail={Mitra.data?.ktp_selfie_pic_url}
                data={Mitra.data}
                mitraType={Mitra.data?.mitra_type}
                status={status}
              />
            )
          },
          {
            id: "usaha",
            title: t("label_mitra_business").toUpperCase(),
            view: (
              <CardDetailUsaha
                mitraDocUrl={Mitra.data?.business_document_pic_url}
                documentType={Mitra.data?.business_document_type}
                mitraFullAddress={mitraFullAddress(Mitra.data)}
                setStatusPopup={setStatusPopup}
              />
            )
          },
          {
            id: "petani",
            title: t("label_farmer").toUpperCase(),
            view: <CardDetailFarmer id={Mitra.data?.id} />
          }
        ]
      })
    }
  }, [Mitra.data])

  const getTabContents = () => {
    const labelList = [t("label_detail_mitra").toUpperCase(), t("label_document").toUpperCase()]

    const componentList = [
      <CardDetailMitra
        key={0}
        titleImage={Mitra.data?.mitra_pic_url}
        titleCardDetail={Mitra.data?.name + " (" + Mitra.data?.mitra_type_name + ")"}
        descriptionLeft={descriptionLeft(Mitra.data)}
        descriptionRight={descriptionRight(Mitra.data)}
        flatIconAndText2Rows={flatIconAndText2Rows(Mitra.data)}
        data={Mitra.data}
        mitraType={Mitra.data?.mitra_type}
        history={history}
        status={status}
      />,
      <CardDetailUsaha
        key={1}
        mitraType={Mitra.data?.mitra_type}
        npwp={Mitra.data?.npwp_no}
        npwpImage={Mitra.data?.other_image}
        ktpImage={Mitra.data?.ktp_pic_url}
        swafoto={Mitra.data?.ktp_selfie_pic_url}
        suratTugas={Mitra.data?.ktp_selfie_pic_url}
        kkImage={Mitra.data?.business_document_pic_url}
        documentPerusahaan={Mitra.data?.business_document_pic_url}
        structurOrganisasi={Mitra.data?.business_document_pic_url}
        setStatusPopup={setStatusPopup}
        ktp={Mitra.data?.ktp_no}
        nama={Mitra.data?.name}
      />
    ]

    if (
      status === ROUTING_STATUS.STATUS_STRING.ACTIVE ||
      status === ROUTING_STATUS.STATUS_STRING.INACTIVE
    ) {
      labelList.push(t("label_farmer").toUpperCase())
      labelList.push(t("contract").toUpperCase())
      componentList.push(<CardDetailFarmer id={Mitra.data?.id} />)
      componentList.push(
        <ContractTab
          contractLog={Mitra.data?.contract_logs}
          fileUrl={Mitra.data?.file_contract_url}
          startDate={Mitra.data?.contract_date_start}
          endDate={Mitra.data?.contract_date_end}
          fileName={Mitra.data?.file_contract_name}
          fileSize={Mitra.data?.file_contract_size}
        />
      )
      labelList.push(t("label_status_history").toUpperCase())
      componentList.push(
        <StatusHistoryTab id={id} />
      )
    }

    if (status) {
      labelList.push(t("label_log").toUpperCase())
      componentList.push(<TabLog historyTabEnum={ENUM_LOG.MITRA} id={id} />)
    }

    return {
      labels: labelList,
      contents: componentList
    }
  }

  const handleReason = (e) => {
    setRejectReasons({
      ...rejectReasons,
      reasons: e.target.value
    })
  }

  const formReason = (
    <>
      <Formik enableReinitialize innerRef={formRef} initialValues={rejectReasons}>
        <Form>
          <TextAreaInput
            name={"rejectReason"}
            placeholder={t("placeholder_reject_reason")}
            label={t("label_mitra_reject_reason")}
            editable={false}
            onKeyUp={handleReason}
            withoutFeedback={true}
          />
        </Form>
      </Formik>
    </>
  )

  const handleSyncERP = () => {
    const code = Mitra.data.code
    const urlName = "mitra"
    dispatch(syncErp(urlName, code))
  }

  const listDropdown = [
    {
      title: t("label_edit_mitra"),
      icon: ICON_CONSTANTS.EDIT,
      action: () => history.push(RoutesConstants.MITRA.EDIT_MITRA(status, id)),
      showed: Mitra?.data?.mitra_activation?.toUpperCase() === ROUTING_STATUS.STATUS_ENUM.ACTIVE
    },
    {
      title: capitalize(t("renew_contract")),
      icon: ICON_CONSTANTS.DOCUMENT_WHITE,
      action: () => setShowPopupApprove(true),
      showed: Mitra?.data?.mitra_activation?.toUpperCase() === ROUTING_STATUS.STATUS_ENUM.ACTIVE
    },
    {
      title: "Sync data ERP",
      icon: ICON_CONSTANTS.SYNC,
      action: handleSyncERP,
      showed: privileges.indexOf(PRIVILEGE_ENUM.CREATE_MITRA) > -1
    }
  ]

  const uploadContractForm = (
    <FormikProvider value={formik}>
      <SelectDateRange
        label={t("contact_term")}
        required={Mitra.data?.status === UI_STATUS.ACTIVE}
        openDate={openDate}
        setOpenDate={setOpenDate}
        placeholder={capitalize(t("placeholder_select_date_range"))}
        value={formik.values.contract_date}
        setValue={(e) => formik.setFieldValue("contract_date", e)}
        setSelectedDate={setSelectedDate}
        selectedDate={selectedDate}
      />
      <UploadComponent
        label={t(`contract_document`)}
        required={Mitra.data?.status === UI_STATUS.ACTIVE}
        name="document_name"
        onDeleteFileList={() => {
          setFileAttachments([])
          formik.setFieldValue("file_contract_url", undefined)
          formik.setFieldValue("file_contract_name", undefined)
          formik.setFieldValue("file_contract_size", undefined)
        }}
        fileList={fileAttachments}
        typeUpload={"pdf"}
        editable={true}
        onChange={(values) => {
          setFileAttachments([values])
          formik.setFieldValue("file_contract_name", values.name)
          formik.setFieldValue("file_contract_size", values.size)
          dispatch(uploadAction({ data: values, type: UPLOAD.BUSINESS_DOCUMENT }))
        }}
        placeholder={<UploadIcon />}
        maxSize={VARIABLE_CONSTANT.MAX_SIZE_25_MB}
        maxSizeText={VARIABLE_CONSTANT.MAX_SIZE_25_MB_TEXT}
        isLoading={General.loading}
        customFilePreview={{ top: "calc(65% + 20px - 1.25rem)" }}
      />
    </FormikProvider>
  )

  function inactiveUserMitra() {
    dispatch(getCheckCanDeactivate(id))
  }

  const handleSubmitChangeStatus = (values) => {
    const payload = {
      reason: values.reason,
      file_url: values.file_url,
      file_name: values.file_name,
      file_size: values.file_size
    }

    if (Mitra?.data?.total_farmer > 0) {
      payload.new_mitra_id = values.new_mitra_id
    }

    setSwalRedirect(RoutesConstants.MITRA.DETAIL_MITRA(ROUTING_STATUS.STATUS_STRING.INACTIVE, id))
    dispatch(deactivateStatusMitra(id, payload))
  }

  const mapDetail = (
    <Card className={"mb-0"}>
      <CardBody>
        <BaseMap
          latitude={Mitra?.data?.latitude}
          longitude={Mitra?.data?.longitude}
          icon={ICON_CONSTANTS.MARKER_MITRA}
        />
        {/*Ai Style*/}
        <div className={"px-0 py-5 d-flex justify-content-between align-items-center"}>
          <div className={"d-flex flex-column"} style={{ gap: 4 }}>
            <span className={"text-harvest-primary font-size-h4 font-weight-bolder"}>
              {Mitra.data?.name}
            </span>
            <span className={"text-dark-50"}>{Mitra.data?.address}</span>
            <span className={"text-dark-50"}>
              {[
                Mitra.data?.sub_district,
                Mitra.data?.district,
                Mitra.data?.regency,
                Mitra.data?.province + " " + Mitra.data?.postal_code
              ]
                .filter(Boolean)
                .join(", ")}
            </span>
          </div>
          <Button
            variant={"primary"}
            className={"d-flex align-items-center text-nowrap ml-6 px-5 py-3"}
            onClick={() => {
              const lat = Mitra?.data?.latitude
              const lng = Mitra?.data?.longitude
              window.open(
                `https://www.google.com/maps?q=${lat},${lng}`,
                "_blank",
                "noopener,noreferrer"
              )
            }}>
            <SVG className={"mr-2"} src={toAbsoluteUrl(ICON_CONSTANTS.DIRECTION_WHITE)} />
            {t("open_google_map")}
          </Button>
        </div>
      </CardBody>
    </Card>
  )

  return (
    <>
      {/* Popup Success */}
      <Popup
        show={showPopup.show}
        body={showPopup.body}
        onClick={() => {
          setShowPopup({
            show: false,
            body: ""
          })
        }}
      />
      <Popup
        bodyCustom={mapDetail}
        show={showPinLocation}
        titleCustom={<h5 className="font-weight-bold mb-0">{t("mitra_location")}</h5>}
        size={"lg"}
        closeButton={true}
        onCancel={() => setShowPinLocation(false)}
        showButton={false}
        bodyCustomClassName={"p-0 mb-0"}
        staticBackdrop={true}
      />

      {/* Popup for reject */}
      <PopupQuestion
        show={showPopupReject}
        title={t("messages_title_mitra_reject_reason")}
        bodyCustom={formReason}
        textOk={t("button_next")}
        onCancel={() => {
          setShowPopupReject(false)
          setRejectReasons({
            reasons: ""
          })
        }}
        disable={rejectReasons.reasons.length > 0 ? false : true}
        onOk={() => {
          handleApproval(ROUTING_STATUS.STATUS_ENUM.REJECTED, rejectReasons.reasons, null)
          setShowPopupReject(false)
          setSwallIcon(toAbsoluteUrl(ILLUSTRATION_CONSTANTS.MITRA.SUCCESS_REJECT))
          setSwalRedirect(RoutesConstants.MITRA.LIST_MITRA(ROUTING_STATUS.STATUS_ENUM.REJECTED))
        }}
      />

      <PopupQuestion
        show={showPopupApprove}
        title={t("upload_contract").toUpperCase()}
        bodyCustom={uploadContractForm}
        textOk={t("button_submit")}
        onCancel={() => {
          setShowPopupApprove(false)
          setFileAttachments([])
          formik.resetForm()
          setSelectedDate(false)
          setOpenDate(false)
        }}
        footerClassName={"w-full"}
        disable={
          Mitra.data?.status === UI_STATUS.ACTIVE
            ? !(
                formik.values?.file_contract_url &&
                formik.values.file_contract_url.length > 0 &&
                selectedDate
              )
            : false
        }
        onOk={() => {
          formik.handleSubmit()
          setShowPopupApprove(false)
          setSwallIcon(toAbsoluteUrl(ILLUSTRATION_CONSTANTS.MITRA.SUCCESS_APPROVE))
          setSwalRedirect(
            RoutesConstants.MITRA.LIST_MITRA(ROUTING_STATUS.STATUS_ENUM.ACTIVE) +
              getUrlParsingPageFilter({
                contract_status: MITRA_ACTIVE_CONTRACT_STATUS_ENUM.ALL_CONTRACTS
              })
          )
        }}
      />

      {/* Modal Change Status */}
      <ModalChangeStatus
        show={showModalChangeStatus}
        onClose={() => {
          setShowModalChangeStatus(false)
          dispatch(resetCheckCanDeactivate())
        }}
        onSubmit={handleSubmitChangeStatus}
        listMitra={listMitra}
        totalFarmer={Mitra?.data?.total_farmer || 0}
        isLoading={General.loading}
      />

      <TabsComponent labelTab={getTabContents().labels} componentTab={getTabContents().contents} />
    </>
  )
}